module.exports = __webpack_public_path__ + "static/media/loader.d8954a08.svg";